import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const tidal: MusicService = {
  id: 'tidal',
  name: 'Tidal',
  shortName: 'Tidal',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: true,
  isAlbumTransferSupported: true,
  color: {
    primary: '#000000',
    label: '#2424FF',
    background: '#69698d',
    text: '#00a6a6',
  },
  importerID: ImporterID.Tidal,
  musicAPIID: MusicAPIIntegrationID.Tidal,
  linkType: 'tidal',
  limits: {
    addingTracks: 20,
  },
  assets: {
    logo: { light: 'tidal-light.svg', dark: 'tidal-dark.svg' },
    logoPadding: { light: 'tidal-light-padding.svg', dark: 'tidal-dark-padding.svg' },
    logoColor: { light: 'tidal-color-light.svg', dark: 'tidal-color-dark.svg' },
    logoColorPadding: {
      light: 'tidal-color-light-padding.svg',
      dark: 'tidal-color-dark-padding.svg',
    },
    logoOnBackground: 'tidal-dark.svg',
  },
  whatIsDescription: musicServiceMessages.tidalWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: false,
    doesSupportMovingTracks: false,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: true,
    doesSupportFetchingLibraryAlbums: true,
    doesSupportFetchingAlbums: true,
    doesSupportFetchingAlbumTracks: true,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: true,
    doesSupportFetchingLibraryArtists: true,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: true,
    doesSupportRemovingArtistsFromLibrary: true,
    doesSupportSearchByISRC: true,
    doesReturnISRC: true,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: true,
    doesReturnUserCountry: true,
    maxLimit: 20,
  },
};
